import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RegisterViewRequest {
  viewType: ViewType;
  entityId: number;
  sessionToken: string;
}

export interface RegisterViewResponse {
  message: string;
  isNewView: boolean;
}

export enum ViewType {
  IndependentProfile = 1,
  JobOffer = 2
}

@Injectable({
  providedIn: 'root'
})
export class ViewTrackingService {
  
  constructor(private http: HttpClient) {}
  
  public registerView(request: RegisterViewRequest): Observable<RegisterViewResponse> {
    return this.http.post<RegisterViewResponse>(`${environment.api.url}/Views/register`, request);
  }
  
  public getViewsCount(viewType: ViewType, entityId: number): Observable<number> {
    return this.http.get<number>(`${environment.api.url}/Views/count/${viewType}/${entityId}`);
  }
  
  public generateSessionToken(): string {
    return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}